import createSecureStorage from "Utils/Storage/createSecureStorage";
import type { LocalStorageKey } from "Utils/Storage/LocalStorage/LocalStorageKeys";

/**
 * Secure wrapper for localStorage operations with error handling
 * All operations are wrapped in try-catch blocks and log errors if they fail
 */

const storage = createSecureStorage<LocalStorageKey>(
  "localStorage",
  () => window.localStorage,
);

export const isLocalStorageAvailable = storage.isAvailable;
export const getLocalStorageItem = storage.getItem;
export const setLocalStorageItem = storage.setItem;
export const removeLocalStorageItem = storage.removeItem;
export const clearLocalStorage = storage.clear;
export const getLocalStorageJSON = storage.getJSON;
export const setLocalStorageJSON = storage.setJSON;
